/* eslint-disable max-classes-per-file */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.facetForm = this.querySelector('form');
    this.facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const params = new URLSearchParams(window.location.search);
    let isFiltered = false;
    let isSorted = false;

    if (params.size > 0) {
      params.forEach((key) => {
        if (key.toLowerCase().startsWith('filter.')) {
          isFiltered = true;
        }
        if (key.toLowerCase() === 'sort_by') {
          isSorted = true;
        }
      });
    }

    FacetFiltersForm.toggleElements(isFiltered || isSorted);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static toggleElements(disable = true) {
    const $productGridSectionsToHide = document.querySelectorAll('.product-grid-section');
    const $mainProductGridContainer = document.getElementById('ProductGridContainer');
    const $facetsWrapper = document.getElementById('main-collection-filters');
    window?.SDG?.updateProductItemView(window?.SDG?.productItemView);
    window?.SDG?.updateProductGridColumns(window?.SDG?.preferredColumns, 'desktop');
    window?.SDG?.updateProductGridColumns(window?.SDG?.preferredColumnsMobile, 'mobile');

    if ($productGridSectionsToHide?.length && $mainProductGridContainer) {
      if (!disable) {
        $productGridSectionsToHide.forEach((section) => {
          const $productGridContainer = section.querySelector('.product-grid-container');
          _.removeClass(section, 'hide');
          if ($productGridContainer) {
            _.addClass($productGridContainer, 'scroll-trigger--cancel');
          }
          const $gridItems = section.querySelectorAll('.grid__item');
          if ($gridItems.length) {
            $gridItems.forEach(($item) => {
              _.addClass($item, 'scroll-trigger--cancel');
            });
          }
        });
        _.addClass($mainProductGridContainer, 'hide');
        _.addClass($facetsWrapper, 'facets-wrapper--custom');
      } else {
        $productGridSectionsToHide.forEach((section) => {
          _.addClass(section, 'hide');
        });
        _.removeClass($mainProductGridContainer, 'hide');
      }
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const countContainerMobile = document.getElementById('countContainerMobile');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    if (countContainerMobile) {
      countContainerMobile.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams)
        : FacetFiltersForm.renderSectionFromFetch(url, event, searchParams);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, searchParams) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderClearAllButton(html);
        FacetFiltersForm.renderSortByElement(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        FacetFiltersForm.toggleElements(searchParams !== '');
      });
  }

  static renderSectionFromCache(filterDataUrl, event, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderClearAllButton(html);
    FacetFiltersForm.renderSortByElement(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    FacetFiltersForm.toggleElements(searchParams !== '');
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // If the main collection filters are not hidden, set the product grid to 3 columns
    const mainCollectionFilters = document.getElementById('main-collection-filters');
    if (mainCollectionFilters && !mainCollectionFilters.classList.contains('hide')) {
      const $productGrids = document.querySelectorAll('product-grid');
      $productGrids.forEach(($productGrid) => {
        $productGrid.classList.add('grid--3-col-desktop');
        $productGrid.classList.remove('grid--4-col-desktop');
      });
    }

    // Re-initialize product items
    window.SDG.productItem();
    FacetFiltersForm.updateGridSettings();
  }

  static updateGridSettings() {
    // Update the product grid columns per row
    const preferredColumns = sessionStorage.getItem('preferred-columns') || '4';
    const preferredColumnsMobile = sessionStorage.getItem('preferred-columns-mobile') || '2';

    function updateProductGridColumns(columns, device) {
      const $productGrid = document.getElementById('product-grid');
      if (!$productGrid) return;

      const pattern = device === 'mobile' ? /grid--\d-col-tablet-down/ : /grid--\d-col-desktop/;
      const oldClass = Array.from($productGrid.classList).find((cls) => cls.match(pattern));
      if (oldClass) {
        $productGrid.classList.remove(oldClass);
      }
      $productGrid.classList.add(`grid--${columns}-col-${device === 'mobile' ? 'tablet-down' : device}`);
    }
    updateProductGridColumns(preferredColumns, 'desktop');
    updateProductGridColumns(preferredColumnsMobile, 'mobile');

    // Update the product item default image view
    const preferredProductItemView = sessionStorage.getItem('preferred-product-item-view') || 'on-model';
    window.GridProductItemControlButton.updateProductGridItemView(preferredProductItemView);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    const $activeHiddenFilters = document.querySelectorAll('.js-hidden-active-filters');
    const $newActiveHiddenFilters = parsedHTML.querySelector('.js-hidden-active-filters');
    if ($activeHiddenFilters && $newActiveHiddenFilters) {
      $activeHiddenFilters.forEach((element) => {
        element.replaceWith($newActiveHiddenFilters.cloneNode(true));
      });
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const selectorEl = document.querySelector(selector);

      if (activeFacetsElement.classList.contains('active-facets-mobile')) {
        const filterCount = Number(activeFacetsElement.dataset.filtersCount);
        // When there are no filters, hide the active facets element on mobile
        if (filterCount === 0) {
          selectorEl.classList.add('hide');
        } else {
          selectorEl.classList.remove('hide');
        }
      }
      if (!activeFacetsElement) return;
      selectorEl.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const searchParams = this.createSearchParams(this.facetForm);
    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static renderClearAllButton(html) {
    const $clearAllButtons = document.querySelectorAll('.js-clear-all-button');
    const htmlElement = new DOMParser().parseFromString(html, 'text/html');
    if (!$clearAllButtons.length) return;
    const clearBtnElement = htmlElement.querySelector('.js-clear-all-button');
    if (!clearBtnElement) return;
    const text = clearBtnElement.innerHTML;

    // Hide clear all when there are no filters
    const { filterCount } = clearBtnElement.dataset;
    if (parseInt(filterCount, 10) === 0) {
      $clearAllButtons.forEach((button) => {
        button.classList.add('hide');
      });
    } else {
      $clearAllButtons.forEach((button) => {
        button.classList.remove('hide');
      });
    }

    // Re-render filter text
    $clearAllButtons.forEach((button) => {
      button.innerHTML = text;
    });
  }

  static renderSortByElement(html) {
    const htmlElement = new DOMParser().parseFromString(html, 'text/html');
    const sortByElementMobile = htmlElement.querySelector('#MobileSortBy');
    const sortByElementDesktop = htmlElement.querySelector('#DesktopSortBy');
    const mobileSortBy = document.getElementById('MobileSortBy');
    const desktopSortBy = document.getElementById('DesktopSortBy');

    if (sortByElementMobile && mobileSortBy) {
      // Replace the entire custom-select element to ensure proper initialization
      mobileSortBy.replaceWith(sortByElementMobile);
    }

    if (sortByElementDesktop && desktopSortBy) {
      // Replace the entire custom-select element to ensure proper initialization
      desktopSortBy.replaceWith(sortByElementDesktop);
    }

    const $activeHiddenSortByInputs = document.querySelectorAll('.js-hidden-active-sort');
    const $newActiveHiddenSortByInputs = htmlElement.querySelector('.js-hidden-active-sort');
    if ($activeHiddenSortByInputs && $newActiveHiddenSortByInputs) {
      $activeHiddenSortByInputs.forEach((element) => {
        element.replaceWith($newActiveHiddenSortByInputs.cloneNode(true));
      });
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetToggleButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const preferredColumns = sessionStorage.getItem('preferred-columns') || '4';
    const mainCollectionFilters = document.getElementById('main-collection-filters');
    const productGrids = document.querySelectorAll('.product-grid');

    if (mainCollectionFilters) {
      const isHiding = !mainCollectionFilters.classList.contains('hide');
      mainCollectionFilters.classList.toggle('hide');
      this.button.setAttribute('aria-expanded', (!isHiding).toString());

      if (productGrids && productGrids.length) {
        if (isHiding) {
          productGrids.forEach((productGrid) => {
            productGrid.classList.remove('grid--3-col-desktop');
            productGrid.classList.add(`grid--${preferredColumns}-col-desktop`);
          });
        } else {
          productGrids.forEach((productGrid) => {
            productGrid.classList.remove(`grid--${preferredColumns}-col-desktop`);
            productGrid.classList.add('grid--3-col-desktop');
          });
        }
      }

      const buttonText = this.button.querySelector('.facets-toggle-button__text');
      if (buttonText) {
        const newText = isHiding ? 'Show filter panel' : 'Hide filter panel';
        buttonText.textContent = isHiding ? 'Filter' : 'Hide';
        this.button.setAttribute('aria-label', newText);
      }
    }
  }
}

customElements.define('facet-toggle-button', FacetToggleButton);
